import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

// blama tfkker t9iss had lcode
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
